var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function SendIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6785 12.7357L14.9013 18.1339L18.7118 6.70248L12.6785 12.7357ZM17.2976 5.28827L5.86616 9.09873L11.2643 11.3215L17.2976 5.28827ZM14.0753 21.3808L10.734 13.2661L2.61927 9.9247C1.7625 9.57191 1.80478 8.34434 2.6838 8.05134L20.6838 2.05134C21.4656 1.79075 22.2093 2.53449 21.9487 3.31625L15.9487 21.3162C15.6557 22.1953 14.4281 22.2375 14.0753 21.3808Z", fill: "" })));
}
export var SendIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: SendIconInner }, props))); };
//# sourceMappingURL=SendIcon.js.map